import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { DEFAULT_STALE_TIME_MS } from "@/services/react-query.service/stale-time";
import { useQuery } from "@tanstack/react-query";

import { municipalPropertyRegisterQueryDocument } from "./municipal-property-register-query.gql";

export const useMunicipalPropertyRegister = (registerId: string) => {
  const { currentWorkspace }: ReturnType<typeof useCurrentWorkspaceContext> = useCurrentWorkspaceContext();
  return useQuery({
    queryKey: queryKeys.municipalPropertyRegisters.detail(registerId),
    queryFn: async () => {
      const client = createOperationClient("MunicipalPropertyRegister");
      const response = await client.request(municipalPropertyRegisterQueryDocument, { id: registerId });
      return response.municipalPropertyRegister;
    },
    enabled: !!registerId,
    staleTime: DEFAULT_STALE_TIME_MS,
    meta: { workspaceId: currentWorkspace.id },
  });
};
